module.exports = __webpack_public_path__ + "img/round2-option3.dbb12e2a.png";